export function getHost(){
    // return '112.124.29.148';
    return '121.199.29.173';
    // return 'localhost';
    // return window.location.host.substr(0, window.location.host.indexOf(":"));
}
